<app-modal tabindex="-1" [modalId]="'edit-listing-ground-modal'" [labelledby]="'edit-listing-ground-modal'"
  [ngClass]="isSearchableLocationInputFocused ? 'edit-listing-ground-modal modalScrollHidden' : 'edit-listing-ground-modal'"
  (keydown.escape)="close()">

  <!-- Begin Modal Layout Containers-->
  @if (!isError && !isLoading) {
    @if (!isSuccessResponse) {
      <div
        class="modal--action-list"
        role="dialog"
        aria-modal="true"
        aria-labelledby="edit-listing-ground-modal-title"
        [attr.aria-label]="editListingGroundModalTranslations.ariaLabelUpdateSelectedModal"
        [attr.data-track-region]="headline"
        >
        <header class="modal__header">
          <h1 class="modal__title" id="edit-listing-modal-title" tabindex="-1">
            {{editListingGroundModalTranslations.textEditListingHeader}}
          </h1>
        </header>
        <p class="subTextSpacing fw-bold">{{editListingGroundModalTranslations.textVehicleDescription}}</p>
        <p class="subTextSpacing">{{editListingGroundModalTranslations.textVin}}</p>
        <app-vehicle-status-badge [badgeStatus]="badgeStatus" [dealershipName]="dealershipName"></app-vehicle-status-badge>
        <hr>
          <div class="modal__content">
            <form name="editListingForm" [formGroup]="editListingForm" class="editListingForm" nonvalidate>
              <div class="row">
                <div class="form-group">
                  <label for="price" class="label">{{editListingGroundModalTranslations.textPrice}}</label>
                  <div class="input-wrapper mb-4">
                    <span class="dollar-sign" [ngClass]="isFrenchCanadian ? 'canadian' : 'american'">$</span>
                    @if (!isFrenchCanadian) {
                      <input
                        mask="separator.0"
                        thousandSeparator=","
                        separatorLimit="100000"
                        class="form-control american-input"
                        name="openingPrice"
                        formControlName="price"
                        [class.is-invalid]="isInvalidInputOpeningPrice"
                        pattern="{{regPatternForMultiples}}"
                        id="price"
                        aria-labelledby="opening-price-label opening-price-error"
                        required
                        />
                    }
                    @if (isFrenchCanadian) {
                      <input
                        thousandSeparator=" "
                        separatorLimit="100000"
                        mask="separator.0"
                        class="form-control canadian-input"
                        name="openingPrice"
                        formControlName="price"
                        [class.is-invalid]="isInvalidInputOpeningPrice"
                        pattern="{{regPatternForMultiples}}"
                        id="price"
                        aria-labelledby="opening-price-label opening-price-error"
                        required
                        />
                    }
                  </div>
                  <label for="odometer" class="label">{{editListingGroundModalTranslations.textOdometerMiles}}</label>
                  <div class="input-wrapper mb-4">
                    <input formControlName="odometer"
                      id="odometer"
                      type="text"
                      class="form-control spread__input"
                      [attr.aria-label]="editListingGroundModalTranslations.labelOdometerMiles"
                      [class.is-invalid]="isOdometerInvalid"
                      mask="separator.0"
                      thousandSeparator=","
                      separatorLimit="1000000"
                      [allowNegativeNumbers]="false"
                      >
                  </div>
                  <!-- Searchable vehicle location input -->
                  @if (isSearchableGroundingLocationEnabled) {
                    <label for="vehicleLocationSearchable" class="label">{{editListingGroundModalTranslations.textVehicleLocation}}</label>
                  }
                  @if (isSearchableGroundingLocationEnabled) {
                    <div class="input-wrapper mb-4">
                      <div id="input-icon-container" class="mirror-select-width">
                        <input
                          #searchableLocationInput
                          matInput
                          matAutocompletePosition="below"
                          type="text"
                          class="form-control wrapText"
                          id="vehicleLocationSearchable"
                          data-test-id="app-edit-listing-searchable-location-input"
                          [formControl]="vehicleLocationSearchControl"
                          [matAutocomplete]="locationAutoComplete"
                          [placeholder]="editListingGroundModalTranslations.locationInputPlaceholderText"
                          [attr.aria-label]="editListingGroundModalTranslations.textVehicleLocation"
                          (blur)="handleInputValueOnBlur()"
                          (focus)="setSearchableLocationFocused(true)"
                          (focusout)="setSearchableLocationFocused(false)"
                          >
                        <i class="me-1 allycon-search" (click)="focusLocationInput()"></i>
                      </div>
                      <mat-autocomplete #autocomplete #locationAutoComplete="matAutocomplete"
                        [displayWith]="displayLocationNameInAutocomplete"
                        (optionSelected)="onOptionSelected($event)">
                        @for (option of filteredOptions | async; track option) {
                          <mat-option [value]="option" class="autoCompleteOption">
                            {{option.name}}
                          </mat-option>
                        }
                        @if ((filteredOptions | async)?.length === 0) {
                          <mat-option id="noLocationResults" disabled>
                            {{editListingGroundModalTranslations.noResultsMatchingSearchText}}
                          </mat-option>
                        }
                      </mat-autocomplete>
                    </div>
                  }
                  <!-- Non-searchable vehicle location select -->
                  @if (!isSearchableGroundingLocationEnabled) {
                    <label for="vehicleLocation" class="label">{{editListingGroundModalTranslations.textVehicleLocation}}</label>
                  }
                  @if (!isSearchableGroundingLocationEnabled) {
                    <div class="select-wrapper mb-4">
                      <select formControlName="vehicleLocation" id="vehicleLocation" class="custom-select wrapText"
                        (click)="analyticsHidePiiLocationDropDown()"
                        data-test-id="app-edit-listing-location-select"
                        >
                        <option [ngValue]="'default'">{{editListingGroundModalTranslations.textSelect}}</option>
                        @for (location of locationOptions; track location) {
                          <option [ngValue]="location">{{location.name}}</option>
                        }
                      </select>
                    </div>
                  }
                  <label for="exteriorColor" class="label">{{editListingGroundModalTranslations.textExteriorColor}}</label>
                  <div class="select-wrapper mb-4">
                    <select formControlName="exteriorColor" id="exteriorColor" class="custom-select wrapText" (click)="analyticsHidePiiColorDropDown()">
                      <option [ngValue]="'default'">{{editListingGroundModalTranslations.textSelect}}</option>
                      @for (color of exteriorColorOptions; track color) {
                        <option [ngValue]="color.colorCode" [selected]="color.installed">{{color.shortDescription}}</option>
                      }
                    </select>
                  </div>
                  <div class="custom-control custom-checkbox border-primary">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="groundVehicle"
                      aria-label="Ground Vehicle"
                      formControlName="vehicleGrounded"
                      (click)="toggleGroundedValue()"
                      [checked]="groundedValue"
                      />
                    <label for="groundVehicle" class="custom-control-label">
                      <span class="fw-bold">{{editListingGroundModalTranslations.textVehicleGrounded}}</span>
                    </label>
                  </div>
                </div>
              </div>
            </form>
            <div class="modal__actions buttonTopMargin">
              <button
                class="btn btn-primary me-md-2 mb-3 mb-md-0"
                allytmln="Update Listing"
                data-track-elem="button"
                data-track-name="Update Listing"
                [attr.aria-label]="textUpdateListing"
                (click)="updateListing()">
                {{editListingGroundModalTranslations.textUpdateListing}}
              </button>
              <button
                class="btn cancel btn-link outline-focus ms-md-2"
                [attr.aria-label]="textCancel"
                (click)="close()">
                <span>{{editListingGroundModalTranslations.textCancel}}</span>
              </button>
            </div>
          </div>
          <div class="modal-close-container text-end">
            <button
              id="edit-listing-modal-close"
              class="modal__close action_list_modal_close"
              aria-label="Close modal"
              (click)="close()"
              data-track-elem="icon"
              data-track-name="close"
              data-track-trigger="close"
              >
              <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      }
      @if (isSuccessResponse) {
        <div
          class="modal--action-list"
          role="dialog"
          aria-modal="true"
          aria-labelledby="edit-listing-ground-modal-title"
          [attr.aria-label]="editListingGroundModalTranslations.textSuccessHeader"
          [attr.data-track-region]="headline"
          >
          <header class="modal__header">
            <h1 class="modal__title" id="edit-listing-modal-success" tabindex="-1">
              <em class="allycon-checkmark text-success" aria-hidden="true" alt="success-icon"></em>
              {{editListingGroundModalTranslations.textSuccessHeader}}
            </h1>
          </header>
          <div class="modal__content">
            <span> {{editListingGroundModalTranslations.textSuccessMessage}}</span>
            <div class="modal__actions buttonTopMargin">
              <button
                class="btn btn-primary me-md-2 mb-3 mb-md-0"
                [attr.aria-label]="editListingGroundModalTranslations.textClose"
                (click)="close()">
                <span>{{editListingGroundModalTranslations.textClose}}</span>
              </button>
            </div>
          </div>
          <div class="modal-close-container text-end">
            <button
              id="edit-listing-modal-close-success"
              class="modal__close action_list_modal_close"
              aria-label="Close modal"
              (click)="close()"
              data-track-elem="icon"
              data-track-name="close"
              data-track-trigger="close"
              >
              <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      }
    }
    @if (isLoading) {
      <div class="spinner-container">
        <app-spinner></app-spinner>
      </div>
    }
    @if (isError) {
      <div class="error-container">
        <button
          id="error-close"
          class="error__close"
          aria-label="Close modal"
          (click)="close()"
          (keydown.escape)="close()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
        <div class="content text-center">
          <span class="text-danger" aria-hidden="true"><app-error-icon fill="currentColor"></app-error-icon></span>
          <p>{{errorMessage}}</p>
        </div>
      </div>
    }

    <ng-template #spinner>
      <div class="spinner-container">
        <app-spinner></app-spinner>
      </div>
    </ng-template>

    <ng-template #error>
      <div class="error-container">
        <button
          id="error-close"
          class="error__close"
          aria-label="Close modal"
          (click)="close()"
          (keydown.escape)="close()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
          >
          <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
        </button>
        <div class="content text-center">
          <span class="text-danger" aria-hidden="true"><app-error-icon fill="currentColor"></app-error-icon></span>
          <p>{{errorMessage}}</p>
        </div>
      </div>
    </ng-template>

    <!-- End Modal Layout Containers-->
    <!-- Begin Templates -->
    <!-- Begin Form Template-->
    <!--End Form Template -->
  </app-modal>
